import React from 'react';

import Transition from '../components/transition';

export default ({ children, location }) => (
  <Transition location={location}>{children}</Transition>
)
